import React from 'react';

export default function NotFound(props) {
  return (
    'Oops! Page not found'
  )
}